import { createSelector } from 'reselect';
import { selectStore } from './view';

export const selectDownloadingJobs = createSelector(
  selectStore,
  (s) => s.downloadingJobs
);
